module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1ec7e176f34199535206e508f86af5fa.1ec7e176.png";